import { IconBus16, IconWalk16 } from '@cian/ui-kit/icons';
import { UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './GeoTravelTime.css';
import { ETransportType } from '../../../../repositories/dailyrent/entities/underground_for_mobile_site/UndergroundForMobileSite';

interface IGeoTravelTimeProps {
  transportType: ETransportType;
  time: string;
}

export const GeoTravelTime: React.FC<IGeoTravelTimeProps> = ({ transportType, time }) => {
  const Icon = transportType === ETransportType.Walk ? IconWalk16 : IconBus16;

  return (
    <div className={styles['container']}>
      <div data-name={transportType} className={styles['icon']}>
        <Icon display="block" color="text-secondary-default" />
      </div>

      <UIText2 display="inline" color="text-secondary-default">
        {time}
      </UIText2>
    </div>
  );
};
